import axios from 'axios';

export const state = {
  eieInvestments: [],
  totalElements: 0,
  nextToken: null,
  currPage: 0,
  loading: false,
};

export const mutations = {
  clearEieInvestments(context) {
    context.eieInvestments = [];
    context.currPage = 0;
    context.nextToken = null;
    context.totalElements = 0;
  },

  setEieInvestments(context, newInvestments) {
    const { elems, nextToken } = newInvestments;

    elems.forEach((investment) => {
      const index = context.eieInvestments.findIndex(item => item.id === investment.id);

      if (index === -1) {
        // Element not found in the array, add it
        context.eieInvestments.push(investment);
      } else {
        // Element found in the array, update it
        context.eieInvestments[index] = investment;
      }
    });

    context.nextToken = nextToken;
    context.totalElements = context.eieInvestments.length;
    context.numberOfPages = Math.ceil(context.totalElements / context);
  },

  setPagination(context, page) {
    context.currPage = page;
  },

  initiateCancellation(context, id) {
    context.eieInvestments = context.eieInvestments.map(investment => (investment.id === id ? ({
      ...investment,
      status: 'cancelling',
    }) : investment));
  },

  setLoading(context, value) {
    context.loading = value;
  },
};


export const getters = {
  totalElements: currenctState => currenctState.totalElements,
  hasNextPage: currenctState => currenctState.nextToken !== undefined,
};

// const MAX_PAGE_TO_FETCH = 110;

export const actions = {
  async clearEieInvestments({ commit, rootState }, params) {
    commit('clearEieInvestments');
  },

  async getEieInvestments({ commit, rootState }, params) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;

      const { currPage } = eieInvestmentsStore.state;
      const nextPage = params.page;
      const rowsPerPage = params.per_page;
      const { order } = params;
      const totalElements = eieInvestmentsStore.state.eieInvestments.length;
      const { nextToken } = eieInvestmentsStore.state;

      if (currPage !== 0 && (nextPage * rowsPerPage < totalElements || nextToken === undefined)) {
        return;
      }

      const options = {
        headers: {
          Authorization: jwtToken,
        },
        params: {
          pageSize: rowsPerPage,
          nextToken,
          order,
        },
      };

      if (params.userId) {
        options.params.userId = params.userId;
      }

      if (params.status) {
        options.params.status = params.status;
      }

      commit('setLoading', true);

      const eieInvestments = await axios.get(`${window.BASE_API.MKI_ADMIN_BASE}/investments/list`, options)
        .then(response => response.data || []);

      commit('setEieInvestments', eieInvestments);
      commit('setPagination', nextPage);
    } catch (err) {
      console.error(err);
    }
    commit('setLoading', false);
  },

  async cancelInvestment({ commit, rootState }, id) {
    // eslint-disable-next-line no-console
    console.info('for id: ', id);
    let result;
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      commit('setLoading', true);

      result = await axios.post(`${window.BASE_API.MKI_ADMIN_BASE}/investments/cancel`, {
        id,
      }, {
        headers: {
          Authorization: jwtToken,
        },
      });

      commit('initiateCancellation', id);
    } catch (err) {
      console.error(err);
    }
    commit('setLoading', false);

    return result;
  },
  async getSigningDocumentUrl({ commit, rootState }, requestData) {
    const { userId, id } = requestData;
    try {
      const response = await axios.get(`${window.BASE_API.MKI_ADMIN_BASE}/downloads/signingDocument/investment/${id}/user/${userId}`);

      return response.data;
    } catch (err) {
      console.error('Error downloading signing document', err);
      throw new Error(err);
    }
  },
  async downloadSurveyPdf({ commit, rootState }, requestData) {
    const { userId, createdAt } = requestData;
    try {
      const response = await axios.get(`${window.BASE_API.EXPLORATION}/exploration/pdf/user/${userId}/created/${createdAt}`);

      return {
        data: response.data,
        headers: response.headers,
      };
    } catch (err) {
      throw new Error(err);
    }
  },
};

const eieInvestmentsStore = {
  state,
  mutations,
  getters,
  actions,
};

export default eieInvestmentsStore;



// WEBPACK FOOTER //
// ./src/store/eieInvestments/eieInvestmentsStore.js